<template>
  <div class="new-dialog">
    <el-dialog title="修改头像" :visible.sync="visible" width="680px" top="calc((100vh - 613px) / 2)" :close-on-click-modal="false" :before-close="closeDialog">
      <div>
        <CropperImage ref="cropperImage" :Name="cropperName" @uploadImgSuccess="handleUploadSuccess" />
        <!-- <div class="upImg">
          <el-upload :action="action" :class="{disabled:imageUrl}" list-type="picture-card" :limit=1 :headers="headers" accept=".jpg,.jpeg,.png" :on-success="uploadSuccess" :on-remove="removeImg">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">取消</el-button>
        <!-- :disabled="!imageUrl" -->
        <el-button size="small" type="primary" @click="onSubmitstep()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax"
import CropperImage from "./CropperImage"

export default {
  name: "email",
  components: {
    CropperImage
  },
  props: {
    visible: Boolean,
  },
  data () {
    return {
      formValidate: {
        mainImage: '',
      },
      ruleValidate: {
        mainImage: [
          { required: true, message: '请上传封面', trigger: 'blur' }
        ],
      },
      //裁切图片参数
      cropperModel: false,
      cropperName: '',
      imgName: '',
      imgVisible: false,

      action: '/services/user/uploadAvatar',
      headers: { 'token': localStorage.getItem('userToken') },
      dialogVisible: false,
      imageUrl: null,
    }
  },
  methods: {
    base64ToBlob (base64Data) {
      let arr = base64Data.split(','),
        fileType = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        l = bstr.length,
        u8Arr = new Uint8Array(l)

      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l)
      }
      return new Blob([u8Arr], {
        type: fileType
      })
    },
    blobToFile (newBlob, fileName) {
      newBlob.lastModifiedDate = new Date()
      newBlob.name = fileName
      return newBlob
    },

    //封面设置
    uploadPicture (name) {
      this.cropperName = name
      this.cropperModel = true
    },
    //图片上传成功后
    handleUploadSuccess (data) {
      console.log(data)
      switch (data.name) {
        case 'flagImg':
          this.formValidate.mainImage = 'http://ydfblog.cn/dfs/' + data.url
          console.log('最终输出' + data.name)
          break
      }
      this.cropperModel = false
    },
    //  保存
    onSubmitstep () {
      this.$refs.cropperImage.$refs.cropper.getCropData(data => { //获取截图的base64格式数据
        console.log(data)

        const blob = this.base64ToBlob(data)
        const file = this.blobToFile(blob, '123.jpg')
        console.log(file)
        let formData = new FormData()
        formData.append('file', file, "DX.jpg")
        //调用axios上传
        httpAjax({
          url: '/services/user/uploadAvatar',
          method: 'post',
          data: formData
        }).then((res) => {
          if (res.success) {
            httpAjax({
              url: '/services/user/update/my',
              method: 'put',
              data: { avatar: res.data }
            }).then((response) => {
              if (response.success) {
                this.$message({
                  message: '用户头像修改成功',
                  type: 'success'
                })
                this.$emit('uploadSuccess')
                this.$parent.imageVisible = false
              } else {
                this.$message({
                  message: response.msg,
                  type: 'error'
                })
              }
            })
          }
        })


      })


    },
    // 上传成功
    uploadSuccess (response) {
      console.log(response)
      if (response.success) {
        this.imageUrl = response.data
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      }
    },
    // 删除图片
    removeImg (file, fileList) {
      setTimeout(() => {
        this.imageUrl = null
      }, 800)
    },
    //  关闭
    closeDialog () {
      this.$parent.imageVisible = false
    }
  }
}
</script>

<style scoped lang="less">
.upImg {
  padding-bottom: 24px;
}

.disabled {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>